var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1527 19.0943H20.0686L19.6844 18.7238C21.0756 17.1102 21.8403 15.05 21.8388 12.9194C21.8388 11.1553 21.3157 9.43083 20.3356 7.96404C19.3555 6.49726 17.9625 5.35404 16.3327 4.67895C14.7029 4.00386 12.9095 3.82723 11.1793 4.17139C9.44911 4.51554 7.85983 5.36503 6.61243 6.61243C5.36503 7.85983 4.51554 9.44911 4.17139 11.1793C3.82723 12.9095 4.00386 14.7029 4.67895 16.3327C5.35404 17.9625 6.49726 19.3555 7.96404 20.3356C9.43083 21.3157 11.1553 21.8388 12.9194 21.8388C15.1286 21.8388 17.1595 21.0292 18.7238 19.6844L19.0943 20.0686V21.1527L25.9554 28L28 25.9554L21.1527 19.0943ZM12.9194 19.0943C9.50258 19.0943 6.74443 16.3362 6.74443 12.9194C6.74443 9.50258 9.50258 6.74443 12.9194 6.74443C16.3362 6.74443 19.0943 9.50258 19.0943 12.9194C19.0943 16.3362 16.3362 19.0943 12.9194 19.0943Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c028513db51161ff7a3f22013520f563.svg";
export { ForwardRef as ReactComponent };